import React from 'react';
import BlockEditor from '../../../../block-editor/Editor';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../../misc/PublishStatusDot.js';
import update from 'immutability-helper';
import AssetField from '../../../../contentful/AssetField';
import ReactJson from 'react-json-view';
import EntityCollectionField from '../../../../contentful/EntityCollectionField';
import EntityField from '../../../../contentful/EntityField';
import DatePicker, {registerLocale} from 'react-datepicker';
import dpLocale from 'date-fns/locale/nb';
import Entity from '../../../../contentful/Entity';
import entity from '../../../../../model/entity';

import 'react-datepicker/dist/react-datepicker.css';

registerLocale('nb', dpLocale);

const createSearcher = (
  contentType,
  params
) => {
  return ({
    query,
    offset,
    limit
  }) => {
    return entity.search({
      query: query,
      offset: offset,
      limit: limit,
      contentType: contentType,
      options: params
    });
  };
};

class Article extends React.Component {
  constructor(props) {
    super(props);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);

    this.urlUntouched = true;

    this.state = {
      onAdd: true,
      onEdit: true,
      onDelete: true,
      articleUrl: ''
    };
  }

  componentDidMount() {
    if (this.props.article && this.props.article.url) {
      this.urlUntouched = false;
      this.updateUrlState(this.props.article.url.toLowerCase());
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  updateUrlState(url) {
    this.setState({
      articleUrl: url
    });
  }

  handleAssetChange(name, asset) {
    const change = {
      article: {}
    };

    change.article[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleMetaDateChange(e) {
    const newData = {
      article: {}
    };

    newData.article['metadata'] = {
      $set: e.updated_src
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    const newData = {
      article: {}
    };

    let value = e.target.value;

    if (e.target.name === 'title' && (!this.props.article.url || this.urlUntouched)) {
      // Update URL field on title change if empty
      const url = value.replace(/[^\w.,-]/g, '-').toLowerCase();
      newData.article.url = {
        $set: url
      };

      this.updateUrlState(url);
    } else if (e.target.name === 'url') {
      this.urlUntouched = false;
      // Convert spaces to dash on user input
      value = value.replace(/\s/, '-').toLowerCase();
      this.updateUrlState(value);
    }

    if (e.target.type === 'checkbox') {
      value = e.target.checked;
    }

    newData.article[e.target.name] = {
      $set: value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handlePageChange(e) {
    let currentSelection = this.props.article.pages || [];
    const checked = e.target.checked;

    if (checked) {
      if (!currentSelection.includes(e.target.value)) {
        currentSelection.push(e.target.value);
      }
    } else {
      const filtered = currentSelection.filter((value) => {
        return value !== e.target.value;
      });
      currentSelection = filtered;
    }

    const obj = {
      target: {
        name: e.target.name,
        value: currentSelection
      }
    };
    this.handleFieldChange(obj);
  }

  handleMakeModelVariantChange(selections) {
    const change = {
      article: {}
    };

    change.article['makes'] = {
      $set: selections.makes
    };
    change.article['models'] = {
      $set: selections.models
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleDateChange(inputName, date) {
    if (date) {
      if (inputName === 'fromDate') {
        date.setHours(0, 0, 0);
      } else if (inputName === 'toDate') {
        date.setHours(23, 59, 59);
      }
    }

    const event = {
      target: {
        name: inputName,
        value: date
      }
    };

    this.handleFieldChange(event);
  }

  handleDealersUpdate(elem, makeId, tag) {
    if (makeId || tag) {
      // Get all dealers with corresponding makes
      const dealers = this.props.dealers;
      const currentDealers = this.props.article.dealers || [];
      let currentDealerIds = [];

      if (currentDealers.length > 0) {
        currentDealerIds = this.props.article.dealers.map((dealer) => {
          return dealer.id;
        });
      }

      dealers.forEach((dealer) => {
        if (!currentDealerIds.includes(dealer.id)) {
          if (makeId) {
            if (dealer.makeIds.includes(makeId)) {
              currentDealers.push(dealer);
            }
          } else if (tag) {
            if (dealer.groupTags && dealer.groupTags.includes(tag)) {
              currentDealers.push(dealer);
            }
          }
        }
      });

      const event = {
        target: {
          name: 'dealers',
          value: currentDealers
        }
      };

      this.handleFieldChange(event);
    }
  }

  render() {
    const {
      onAdd,
      onEdit,
      onDelete
    } = this.state;

    const article = this.props.article;
    // console.log('article', article);

    // let mmvCls = 'success';
    // if (!article.makes) {
    //   mmvCls = 'danger';
    // } else if (article.model) {
    //   if (!article.model.published) {
    //     mmvCls = 'warning';
    //   } else if (article.model.updated) {
    //     mmvCls = 'info';
    //   }
    // }

    let dealerTags = [];
    this.props.dealers.forEach((dealer) => {
      if (dealer.groupTags && dealer.groupTags.length > 0) {
        dealerTags.push(...dealer.groupTags);
      }
    });
    // Only keep unique
    dealerTags = [...new Set(dealerTags)];

    // Create button group for dealers per brand
    let buttons;
    if (this.props.makes) {
      const allMakes = this.props.makes;
      buttons = (
        <div className="btn-group" role="group">
          {allMakes.map((make, i) => {
            return (
              <button
                key={i}
                type="button"
                className="btn btn-default btn-sm"
                disabled={article.archived || this.props.working}
                onClick={(e) => this.handleDealersUpdate(e, make.id)}
              >
                Alle {make.name}
              </button>
            );
          })}
        </div>
      );
    }

    const predefinedTags = ['Artikkel'];
    const articleMakes = article?.makes ?? [];
    if (articleMakes.length > 0) {
      predefinedTags.push(...articleMakes.map((make) => make.name));
    }
    const articleModels = article?.models ?? [];
    if (articleModels.length > 0) {
      predefinedTags.push(...articleModels.map((make) => make.name));
    }

    return (
      <section className="campaign mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/motorforum/articles/">Artikler</Link></li>
          <li className="active">{this.props.article.title}</li>
        </ol>
        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="pull-right">
              {this.props.working &&
                <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
              }
              {!this.props.article.archived &&
                <button
                  type="submit"
                  className="btn btn-default"
                  disabled={!this.props.modified || this.props.working}
                >
                  {Boolean(this.props.article.id) &&
                    <span>Lagre</span>
                  }
                  {!this.props.article.id &&
                    <Link
                      className="btn btn-success"
                      disabled={this.props.working || article.archived}
                    >
                    Opprett artikkel
                    </Link>
                  }
                </button>
              }
              &nbsp;
              {article.id &&
                <button
                  type="button"
                  className="btn btn-default"
                  disabled={this.props.article.archived || this.props.working}
                  onClick={(e) => {
                    e.preventDefault();
                    const newData = {article: {}};

                    newData.article.id = {
                      $set: 'temp'
                    };

                    newData.article.title = {
                      $set: `Kopi ${article.title}`
                    };


                    if (article.url) {
                      newData.article.url = {
                        $set: `kopi-${article.url}`
                      };
                    }

                    // Create copy of bodytext blocks without ID so we create new ones
                    newData.article.bodytext = {
                      $set: article.bodytext.map((b) => {
                        b.id = undefined;
                        return b;
                      })
                    };

                    const props = update(this.props, newData);
                    this.props.onChange(props, () => this.props.onSave(true));
                  }}
                >
                  <span>Kopier</span>
                </button>
              }
              &nbsp;
              <button
                type="button"
                className="btn btn-success"
                disabled={(this.props.article.published && !this.props.article.updated) || this.props.article.archived || this.props.working || this.props.modified}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.onPublish();
                }}
              >
                <span>Publiser</span>
              </button>
              &nbsp;
              {this.props.onUnpublish &&
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={this.props.article.draft || this.props.article.archived || this.props.working || this.props.modified}
                  onClick={(e) => {
                    e.preventDefault();
                    if (this.props.article.archived) {
                      this.props.onUnarchive();
                    } else {
                      this.props.onUnpublish();
                    }
                  }}
                >
                  <span>Kladd</span>
                </button>
              }
              &nbsp;
              {!this.props.article.archived &&
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={(this.props.working)}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onArchive();
                  }}
                >
                  <span>Arkiver</span>
                </button>
              }
              &nbsp;
              {this.props.article.archived &&
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={(this.props.working)}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onUnarchive();
                  }}
                >
                  <span>Gjenopprett</span>
                </button>
              }
            </div>
            <h1>
              {this.props.article.title} <PublishStatusDot entry={this.props.article} /><br/>
            </h1>
          </div>
          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          {/* Tabs */}
          <ul className="nav nav-tabs" role="tablist">
            <li role="general" className="active">
              <a href="#general" aria-controls="general" role="tab" data-toggle="tab">Generelt</a>
            </li>
            <li role="publishing">
              <a href="#publishing" aria-controls="publishing" role="tab" data-toggle="tab">Publisering</a>
            </li>
            <li role="cta">
              <a href="#cta" aria-controls="cta" role="cta" id="ctaTab" data-target="#cta" data-toggle="tab">Call to action</a>
            </li>
            <li role="metadata">
              <a href="#metadata" aria-controls="files" role="tab" id="metadataTab" data-target="#metadata" data-toggle="tab">Metadata</a>
            </li>
          </ul>

          {/* Tab content */}
          {/* GENERAL TAB */}
          <div className="tab-content mf-margin-bottom-40">
            <div role="tabpanel" className="tab-pane active" id="general">
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <label>Tittel</label>
                  <div className="form-group">
                    <input type="text" className="form-control" name="title" defaultValue={this.props.article.title} disabled={this.props.working || article.archived} onChange={this.handleFieldChange} />
                  </div>
                  <label>URL<em className="small text-muted"></em></label>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      pattern="^([\w#!:;.,?+=&%@!\-/])+?$"
                      name="url"
                      value={this.state.articleUrl}
                      disabled={article.published || this.props.working || article.archived}
                      onChange={this.handleFieldChange}
                    />
                    {article.published && <span className="help-block">Det er ikke mulig å endre URL på publisert artikkel.</span>}
                  </div>
                  <label>Ingress</label>
                  <div className="form-group">
                    <textarea type="text" rows="3" className="form-control" name="caption" defaultValue={this.props.article.caption} disabled={this.props.working || article.archived} onChange={this.handleFieldChange} />
                    <span className="help-block">Kort ingress, brukt i opplisting av artikler.</span>
                  </div>
                  <label>Ikon (SVG)</label>
                  <div className="form-group">
                    <textarea
                      type="text"
                      rows="3"
                      className="form-control"
                      name="icon"
                      defaultValue={this.props.article.icon}
                      disabled={this.props.working || article.archived}
                      onChange={this.handleFieldChange}
                    />
                  </div>
                </div>
                <div className="col-xs-12 col-md-6">
                  <label>Listebilde <em className="small text-muted">(Påkrevet)</em></label>
                  <div className="form-group">
                    <AssetField
                      name="listImage"
                      value={this.props.article.listImage}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || this.props.article.archived}
                      predefinedTags={predefinedTags}
                    />
                  </div>
                  <label>Hovedbilde</label>
                  <div className="form-group">
                    <AssetField
                      name="mainImage"
                      value={this.props.article.mainImage}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || this.props.article.archived}
                      predefinedTags={predefinedTags}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <div className="form-group">
                    <label className="h2">Innhold</label>
                    <hr />
                    <BlockEditor
                      blocks={this.props.article.bodytext}
                      onChange={(blocks) => this.handleAssetChange('bodytext', blocks)}
                      disabled={this.props.working || article.archived}
                      enableTwoColumns
                      enableFaq
                      predefinedTags={predefinedTags}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* PUBLISHING TAB */}
            <div role="tabpanel" className="tab-pane" id="publishing">
              <div className="row">
                <div className="col-xs-12">
                  <div className="alert alert-info">
                    Her finner du innstillingene for publisering av artikkelen.
                    <ul style={{marginTop: '10px'}}>
                      <li style={{paddingTop: '5px'}}><strong>Forhandler</strong>: En artikkel vil kun synes på forhandlersidene den er koblet til, <em>uavhengig av andre publiseringsinnstillinger</em>.</li>
                      <li style={{paddingTop: '5px'}}><strong>Seksjoner</strong>: Velg seksjoner ved å markere i avkrysningboksene. En artikkel som feks kobles til &laquo;Tips&raquo; vil bli synlig under siden &laquo;Tips og råd&raquo;, osv.</li>
                      <li style={{paddingTop: '5px'}}><strong>Tipspunkt</strong>: Valgfritt. Dersom til- og/eller fra-tidspunkt er valgt, vil artikkelen kun være synlig og tilgjengelig fra/til angitt dato.</li>
                      <li style={{paddingTop: '5px'}}><strong>Modell</strong>: Dersom en artikkel kobles til en eller flere modeller, vil artikkelen vises på modellsiden(e), og en preview av bilen(e) vil vises på artikkelen.
                      Artikler som publiseres mot modell, <em>må</em> også kobles mot seksjonen &laquo;Tips&raquo;</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="form-group">
                    <label>Publisert f.o.m. - t.o.m.</label>
                    <div className="row">
                      <div className="col-xs-12">
                        <DatePicker
                          name="startDate"
                          disabled={this.props.working || article.archived}
                          className="form-control"
                          locale="nb"
                          dateFormat="dd.MM.yyyy"
                          selected={article.fromDate}
                          onChange={(date) => this.handleDateChange('fromDate', date)}
                        />
                        &nbsp;-&nbsp;
                        <DatePicker
                          name="expiryDate"
                          disabled={this.props.working || article.archived}
                          className="form-control"
                          locale="nb"
                          dateFormat="dd.MM.yyyy"
                          selected={article.toDate}
                          onChange={(date) => this.handleDateChange('toDate', date)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Publiser til seksjon</label>
                    {article.pagesOptions && article.pagesOptions.map((option) => {
                      return (
                        <div className="checkbox" key={option}>
                          <label>
                            <input
                              name="pages"
                              type="checkbox"
                              value={option}
                              defaultChecked={article.pages.includes(option)}
                              onChange={this.handlePageChange}
                              disabled={this.props.working || article.archived}
                            />
                            {option}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                  <div className="form-group">
                    <label>Kritisk melding</label>
                    <div className="checkbox">
                      <label>
                        <input
                          name="criticalBannerArticle"
                          type="checkbox"
                          defaultChecked={article.criticalBannerArticle}
                          onChange={this.handleFieldChange}
                          disabled={this.props.working || article.archived}
                        />
                        Vis banner på alle sider
                      </label>
                    </div>
                    <div>
                      <label>Banner tekst</label>
                      <input
                        type="text"
                        className="form-control"
                        name="criticalBannerText"
                        defaultValue={this.props.article.criticalBannerText}
                        disabled={!article.criticalBannerArticle || this.props.working || article.archived}
                        onChange={this.handleFieldChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-6">
                  <div className="form-group">
                    <label>Prioritet <em className="small text-muted">(Påkrevet)</em></label>
                    <input
                      type="number"
                      step="1"
                      className="form-control"
                      name="priority"
                      defaultValue={article.priority}
                      disabled={this.props.working || article.archived}
                      onChange={this.handleFieldChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-xs-12 col-sm-6">
                  <div className="form-group">
                    <h3>Publiser til forhandlere</h3>

                    {buttons &&
                      <div className="mf-margin-bottom-20">
                        <label>Basert på merke</label><br />
                        {buttons}
                      </div>
                    }

                    <div className="mf-margin-bottom-20">
                      <label>Basert på tag</label><br />
                      <div className="btn-group" role="group">
                        {dealerTags.map((tag, i) => {
                          return (
                            <button
                              key={i}
                              type="button"
                              className="btn btn-default btn-sm"
                              disabled={article.archived || this.props.working}
                              onClick={(e) => this.handleDealersUpdate(e, null, tag)}
                            >
                              {tag}
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    <h4 className="mf-margin-bottom-20">Artikkelen er publisert til:</h4>
                    <EntityCollectionField
                      name="dealers"
                      value={article.dealers}
                      contentType="forhandler"
                      removeAllButton={true}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || article.archived }
                    />

                    <span className="help-block">
                      Angir hvilke forhandlere kampanjen skal vises for.
                    </span>

                  </div>
                </div>
              </div>
            </div>

            {/* METADATA TAB */}
            <div role="tabpanel" className="tab-pane" id="metadata">
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <label>Intern Sammendrag</label>
                  <div className="form-group">
                    <textarea type="text" className="form-control" name="summary" defaultValue={this.props.article.summary} disabled={this.props.working || article.archived} onChange={this.handleFieldChange} />
                    <span className="help-block">Angi hjelptekst for enkel søkbarhet og skille mellom artiker</span>
                  </div>
                  <div className="form-group">
                    <label>Rå Metadata</label>
                    <br/>
                    <div className="well col-xs-12 col-md-6 well">
                      <ReactJson
                        name={false}
                        src={this.props.article.metadata}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        enableClipboard={false}
                        onEdit={
                          onEdit ? (e) => {
                            this.handleMetaDateChange(e);
                          } : false
                        }
                        onDelete={
                          onDelete ? (e) => {
                            this.handleMetaDateChange(e);
                          } : false
                        }
                        onAdd={
                          onAdd ? (e) => {
                            this.handleMetaDateChange(e);
                          } : false
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-6">
                  <div className="form-group">
                    <div className="clearfix mf-margin-bottom-10">
                      <label>Metadata / OpenGraph</label>
                    </div>
                    {!this.props.modified && article.id &&
                      <Link
                        className="btn btn-default"
                        to={`/opengraph/new/article/${article.id}${article.makes && article.makes.length ? `/${article.makes[0].id}` : ''}`}
                      >Opprett egendefinert metadata</Link>
                    }
                    {this.props.modified && <div className="alert alert-info">Du må lagre artikkelen før du kan gjøre endringer på metadata</div>}
                    <div className="mf-margin-top-10">
                      {this.props.opengraphs && this.props.opengraphs.map((og) => (
                        <Entity key={og.id} disabled={this.props.modified || this.props.working || article.archived} allowEdit={`/opengraph/article/${og.id}`} entity={og} />
                      ))}
                    </div>
                  </div>
                </div>
                {/* <div className="col-xs-12 col-md-6">
                  <h3>Merkebegrensing</h3>
                  <EntityCollectionField
                    name="makes"
                    value={this.props.article.makes}
                    contentType="bilmerker"
                    onChange={this.handleAssetChange}
                    disabled={this.props.working}
                  />
                </div> */}
              </div>
            </div>

            {/* CTA TAB */}
            <div role="tabpanel" className="tab-pane" id="cta">
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="form-group">
                    <label>Tittel</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ctaTitle"
                      defaultValue={this.props.article.ctaTitle}
                      disabled={this.props.working || article.archived}
                      onChange={this.handleFieldChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Tekst</label>
                    <textarea
                      type="text"
                      rows="5"
                      className="form-control"
                      name="ctaText"
                      defaultValue={this.props.article.ctaText}
                      disabled={this.props.working || article.archived}
                      onChange={this.handleFieldChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Knappetekst</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ctaButtonText"
                      defaultValue={this.props.article.ctaButtonText}
                      disabled={this.props.working || article.archived}
                      onChange={this.handleFieldChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>CTA justering</label>
                    <select
                      className="form-control"
                      name="ctaAlign"
                      defaultValue={this.props.article.ctaAlign}
                      disabled={this.props.working || article.archived}
                      onChange={this.handleFieldChange}
                    >
                      <option value="left">Venstrejustert</option>
                      <option value="center">Midtstilt</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Skjemaside</label>
                    <select
                      className="form-control"
                      name="ctaForm"
                      defaultValue={this.props.article.ctaForm}
                      disabled={this.props.working || article.archived}
                      onChange={this.handleFieldChange}
                    >
                      <option value="">-- Velg skjema/side --</option>
                      <option value="Form">Generell skjematype</option>
                      <option value="DealerContact">/Kontakt</option>
                      <option value="Workshop">/Verksted</option>
                      <option value="external">Egendefinert</option>
                    </select>
                  </div>
                  {this.props.article.ctaForm === 'external' &&
                    <div className="form-group">
                      <label>Egendefinert skjema <em className="small text-muted">(Påkrevet)</em></label>
                      <EntityField
                        name="ctaFormExt"
                        contentType="leadSchema"
                        value={this.props.article.ctaForm === 'external' && this.props.article.ctaFormExt}
                        onChange={this.handleAssetChange}
                        disabled={this.props.article.externalCampaignPage || this.props.working || this.props.article.archived || this.props.article.ctaForm !== 'external'}
                        searcher={createSearcher('leadSchema')}
                        searchOnOpen={true}
                        allowEdit={!this.props.modified}
                      />
                    </div>
                  }
                </div>
                <div className="col-xs-12 col-sm-6">
                  <div className="form-group">
                    <label>Ekstern URL</label>
                    <div className="input-group">
                      <div className="input-group-addon">Url</div>
                      <input
                        type="text"
                        className="form-control"
                        name="ctaUrl"
                        defaultValue={this.props.article.ctaUrl}
                        disabled={this.props.working || article.archived}
                        onChange={this.handleFieldChange}
                      />
                    </div>
                  </div>
                  <span className="help-block">Angi ekstern url/nettadresse dersom CTA-knapp skal lede til en ekstern landingsside.</span>
                </div>
              </div>
            </div>
          </div>
          {/* // Tab content */}
        </form>
      </section>
    );
  }
}

Article.defaultProps = {
  article: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {}
};

export default Article;
